import React, { ReactNode } from 'react';

import Loader from '@components/Loader';

interface Props {
  children: ReactNode;
  brand: 'LC' | 'TO';
}

const TO = React.lazy(() => import('./TO'));
const LC = React.lazy(() => import('./LC'));

const ThemeSelector = ({ children, brand }: Props): JSX.Element => (
  <>
    <React.Suspense fallback={<Loader classes="main" />}>
      {brand === 'TO' ? <TO /> : <LC />}
    </React.Suspense>
    {children}
  </>
);

export default ThemeSelector;
